import { ProductInterface } from '@interface/billing/billing.interface';

interface PlanPaidDescriptionInterface {
  subscriptionPlan: ProductInterface;
}

export const PlanPaidDescription = ({ subscriptionPlan }: PlanPaidDescriptionInterface) => {
  const additionalApiCalls = subscriptionPlan.additionalOptions.at(0)?.value;
  return (
    <>
      <p>You&apos;re currently on the {subscriptionPlan.name} plan, which includes:</p>
      <ul>
        <li>
          <b>
            {subscriptionPlan.limits.applications === -1
              ? 'Unlimited Applications'
              : `${subscriptionPlan.limits.applications} Application${subscriptionPlan.limits.applications === 1 ? '' : 's'}`}
          </b>
        </li>
        <li>
          <b>Unlimited Integrations & Consumers</b>
        </li>
        <li>
          <b>{new Intl.NumberFormat('en-IN').format(subscriptionPlan.limits.apiCalls)} API calls</b>
        </li>
        <li>
          <b>Unlimited Webhooks</b>
        </li>
        {additionalApiCalls && (
          <li>
            Additional API calls: <b>{additionalApiCalls} per call</b>
          </li>
        )}
      </ul>
      <p>{subscriptionPlan.description}</p>
    </>
  );
};
